<template>
  <v-container>
    <v-layout
      v-if="
        this.$store.getters.currentUser.infosClientJDE.codeBlocage.length != 0
      "
      pb-12
    >
      <div style="font-weight: bold;font-size: 16px; ">
        Veuillez noter que votre compte est temporairement bloqué puisqu’une ou
        plusieurs factures inscrite(s) à votre compte client SAQ sont en retard.
        Une fois que le règlement complet de l’arriérage sera effectué, vous
        pourrez saisir de nouvelles commandes. Pour toutes questions, merci de
        communiquer avec notre Service de crédit et recouvrement au 514
        254-8686, option 2.
      </div>
    </v-layout>

    <v-layout v-else pb-10>
      <v-flex xs12 pr-10>
        <v-container>
          <div
            v-if="
              dateEstimeeLivraisonTP &&
                this.$store.getters.currentUser.clientData
                  .indCommandeTPAutorise == true
            "
            style="font-weight: bold; color: #00838E;"
            class=""
          >
            Il vous reste

            <span v-if="dateEstimeeCutOffDuration.days() > 0">
              {{ dateEstimeeCutOffDuration.days() + ' jours ' }}
            </span>

            <span
              v-if="
                dateEstimeeCutOffDuration.days() > 0 ||
                  dateEstimeeCutOffDuration.hours() > 0
              "
            >
              {{ dateEstimeeCutOffDuration.hours() + ' heures ' }}
            </span>

            {{ dateEstimeeCutOffDuration.minutes() + ' minutes ' }}

            pour transmettre votre commande pour une livraison

            {{ moment(dateEstimeeLivraisonTP).format('dddd D MMMM YYYY') }}
          </div>

          <div
            v-if="
              dateEstimeeLivraisonTP == null &&
                this.$store.getters.valideTypeClient('TITULAIRE_POUR_REVENTE')
            "
            class="pt-5"
          >
            <span style="font-weight: bold; font-size: 16px;"
              >Service à la clientèle.</span
            >
            <ul>
              <li>Montréal: 514 254-8686 option 1</li>
              <li>Québec: 418 654-2950 option 1</li>
            </ul>
          </div>
        </v-container>

        <v-container>
          <template>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="communication.communication"></div
          ></template>

          <div
            class="pt-5"
            style="color: #00838E; text-decoration: underline; font-weight: bold;"
          >
            Documents d'informations
          </div>

          <!--
          <div class="pb-3 pt-3">
            <v-icon dense color="accent" @click="exportRapportinventaireB2()">
              mdi-file-document
            </v-icon>
            <a
              style=" font-weight: bold; color: black; font-size: 14px;text-decoration: underline;"
              @click="exportRapportinventaireB2()"
            >
              Rapport des produits en inventaire</a
            >
          </div>
          -->

          <v-data-iterator
            :items="fichiers"
            hide-default-footer
            dense
            no-data-text=""
          >
            <template v-if="fichiers != null" v-slot:default="props">
              <v-col
                v-for="item in props.items"
                :key="item.name"
                style="padding:2px"
              >
                <a
                  v-if="item.nomFichier != 'offre.jpg'"
                  style="text-decoration: underline; color: #343232; color: black"
                  class="text-caption text-capitalize"
                  @click="exportFichier(item)"
                  >{{ item.nomFichier }}</a
                >
              </v-col>
            </template>
          </v-data-iterator>
        </v-container>
      </v-flex>

      <v-flex xs6 pr-8>
        <v-flex
          v-if="
            this.$store.getters.currentUser.clientData.indCommandeTPAutorise
          "
        >
          <v-icon class="pb-6 pt-4" style="color: black">shopping_cart</v-icon
          ><span class="pl-3 pb-8" style="font-size: 12px; font-weight: bold;"
            >MES COMMANDES</span
          >

          <v-card class="pt-2 pb-2 pl-5">
            <router-link
              :to="{
                name: 'historique',
                params: {
                  statutCommandeTP: 'EN_ATTENTE_RETOUR_CLIENT'
                }
              }"
            >
              <v-avatar
                class="accent oval"
                size="50"
                style=" border-top-left-radius: 25px;  border-top-right-radius: 25px;"
              >
                <span>{{ nombreCommandeEnAttente }}</span>
              </v-avatar>
              <span class="button pl-5"
                >Veuillez contacter la SAQ pour ces commandes</span
              >
            </router-link>
          </v-card>

          <v-card class="pt-2 pb-2 pl-5">
            <router-link
              :to="{
                name: 'historique',
                params: {
                  statutCommandeTP: 'CONFIRMEE'
                }
              }"
            >
              <v-avatar
                class="accent oval"
                size="50"
                style=" border-top-left-radius: 25px;  border-top-right-radius: 25px;"
              >
                <span>{{ nombreCommandeConfirmee }}</span>
              </v-avatar>
              <span class="button pl-5">Commandes confirmées</span>
            </router-link>
          </v-card>
        </v-flex>

        <v-spacer class="pb-10" />

        <v-flex
          v-if="this.$store.getters.currentUser.clientData.indDemandeIPAutorise"
          class="pb-5"
        >
          <v-icon class="pb-6 pt-5" style="color: black">shopping_cart</v-icon
          ><span class="pl-3 pb-8" style="font-size: 12px; font-weight: bold;"
            >MES DEMANDES</span
          >

          <v-card class="pt-2 pb-2 pl-5">
            <router-link
              :to="{
                name: 'historiqueDemande'
              }"
            >
              <v-avatar
                class="accent oval"
                size="50"
                style=" border-top-left-radius: 25px;  border-top-right-radius: 25px;"
              >
                <span>{{ nombreDemandeEnAttente }}</span>
              </v-avatar>
              <span class="button pl-5 pr-1"
                >Demandes en attente de modifications</span
              >
            </router-link>
          </v-card>

          <v-card class="pt-2 pb-2 pl-5">
            <router-link
              :to="{
                name: 'demandeBrouillon'
              }"
            >
              <v-avatar
                class="accent oval"
                size="50"
                style=" border-top-left-radius: 25px;  border-top-right-radius: 25px;"
              >
                <span>{{ nombreDemandeBrouillon }}</span>
              </v-avatar>
              <span class="button pl-5 pr-5">Demandes brouillons</span>
            </router-link>
          </v-card>
        </v-flex>

        <v-flex>
          <a
            v-if="fichierOffre != null && fichierOffre.contenu != null"
            class="pr-5"
            style="text-decoration: underline;"
            @click="exportFichier(fichierOffre)"
            ><img
              :src="`data:image/jpeg;base64,${fichierOffre.contenu}`"
              width="200"
              height="300"
          /></a>

          <!--
          <a
            v-if="
              fichierCirculaire != null && fichierCirculaire.contenu != null
            "
            style="text-decoration: underline;"
            @click="exportFichier(fichierCirculaire)"
            ><img
              :src="`data:image/jpeg;base64,${fichierCirculaire.contenu}`"
              width="200"
              height="300"
          /></a>-->
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import 'moment/locale/fr'
export default {
  name: 'Accueil',
  data() {
    return {
      fichiers: [],
      fichierOffre: [],
      fichierCirculaire: [],
      filtre: null,
      communication: { communication: null },
      listeProduitsMatrice: [],
      nombreCommandeEnAttente: null,
      nombreCommandeConfirmee: null,

      nombreDemandeEnAttente: null,
      nombreDemandeBrouillon: null,

      headers: [{ value: 'nomFichier', sortable: false }],
      headersMatrice: [
        { value: 'noProduit', sortable: false },
        { value: 'descriptionProduit', sortable: false }
      ],
      dateEstimeeLivraisonTP: null,
      dateEstimeeLivraisonTPValideJusqua: null,
      dateEstimeeCutOffDuration: null,
      heureTombeeLivraisonCDMTp: null,
      heureTombeeLivraisonCDQTp: null
    }
  },
  computed: {},

  beforeMount() {
    console.log(' beforeMount')

    this.obtenirCommunication()

    if (
      this.$store.getters.currentUser.clientData.indCommandeTPAutorise == true
    ) {
      this.obtenirNombreCommandesTPEnAttenteConfirmee()
    }

    if (
      this.$store.getters.currentUser.clientData.indDemandeIPAutorise == true
    ) {
      this.obtenirNombreDemandesEnAttenteBrouillon()
    }

    if (
      this.$store.getters.currentUser.clientData.instructionLivraisonTPData !=
      null
    ) {
      this.obtenirDateLivraisonEstimee()
    }
  },

  methods: {
    obtenirCommunication() {
      console.log(
        'obtenirCommunicationSelonType ',
        this.$store.getters.currentUser.clientData.centreTraitement
      )

      var typeCommunication
      var typeClient = this.$store.getters.currentUser.clientData.typeClient

      if (typeClient != 'TITULAIRE_POUR_REVENTE') {
        typeCommunication = 'AUTRE_DEMANDEUR'
      } else if (typeClient == 'TITULAIRE_POUR_REVENTE') {
        if (
          this.$store.getters.currentUser.clientData.centreTraitement == 'CDM'
        ) {
          typeCommunication = 'TP_COMMANDE_CDM'
        } else {
          typeCommunication = 'TP_COMMANDE_CDQ'
        }
      }

      axios
        .get(`/communication/selontype/${typeCommunication}`)
        .then(response => {
          let resp = response.data
          switch (resp.codeRetour) {
            case 'OK':
              this.communication = resp.resultat
              this.lireDocuments()
              break
            case 'W001':
              break
            default:
              console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
              this.$store.dispatch(
                'afficherError',
                `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
              )
              break
          }
        })
        .catch(error => {
          //console.log('error=' + error)
          let texte = ''
          if (error.response) {
            texte = `Status: ${error.response.status} Data: ${error.response.data}`
            console.log(texte)
          } else {
            texte = `Une erreur technique est survenue: ${error.message}`
          }
          this.$store.dispatch('afficherError', texte)
        })
    },

    obtenirNombreCommandesTPEnAttenteConfirmee() {
      axios
        .get(
          `/accueil/commandeTPRetourClient/${this.$store.getters.currentUser.infosClientJDE.noClientJDE}`
        )
        .then(response => {
          let resp = response.data
          switch (resp.codeRetour) {
            case 'OK':
              this.nombreCommandeEnAttente = resp.resultat
              break
            default:
              console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
              this.$store.dispatch(
                'afficherError',
                `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
              )
              break
          }
        })
        .catch(error => {
          let texte = ''
          if (error.response) {
            texte = `Status: ${error.response.status} Data: ${error.response.data}`
            console.log(texte)
          } else {
            texte = `Une erreur technique est survenue: ${error.message}`
          }
          this.$store.dispatch('afficherError', texte)
        })

      axios
        .get(
          `/accueil/commandeTPConfirmee/${this.$store.getters.currentUser.infosClientJDE.noClientJDE}`
        )
        .then(response => {
          let resp = response.data
          switch (resp.codeRetour) {
            case 'OK':
              this.nombreCommandeConfirmee = resp.resultat
              break
            default:
              console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
              this.$store.dispatch(
                'afficherError',
                `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
              )
              break
          }
        })
        .catch(error => {
          let texte = ''
          if (error.response) {
            texte = `Status: ${error.response.status} Data: ${error.response.data}`
            console.log(texte)
          } else {
            texte = `Une erreur technique est survenue: ${error.message}`
          }
          this.$store.dispatch('afficherError', texte)
        })
    },

    obtenirNombreDemandesEnAttenteBrouillon() {
      axios
        .get(
          `/accueil/demandeEnAttenteModification/${this.$store.getters.currentUser.infosClientJDE.noClientJDE}`
        )
        .then(response => {
          let resp = response.data
          switch (resp.codeRetour) {
            case 'OK':
              this.nombreDemandeEnAttente = resp.resultat
              break
            default:
              console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
              this.$store.dispatch(
                'afficherError',
                `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
              )
              break
          }
        })
        .catch(error => {
          let texte = ''
          if (error.response) {
            texte = `Status: ${error.response.status} Data: ${error.response.data}`
            console.log(texte)
          } else {
            texte = `Une erreur technique est survenue: ${error.message}`
          }
          this.$store.dispatch('afficherError', texte)
        })

      axios
        .get(
          `/accueil/demandeEnBrouillon/${this.$store.getters.currentUser.infosClientJDE.noClientJDE}`
        )
        .then(response => {
          let resp = response.data
          switch (resp.codeRetour) {
            case 'OK':
              this.nombreDemandeBrouillon = resp.resultat
              break
            default:
              console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
              this.$store.dispatch(
                'afficherError',
                `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
              )
              break
          }
        })
        .catch(error => {
          let texte = ''
          if (error.response) {
            texte = `Status: ${error.response.status} Data: ${error.response.data}`
            console.log(texte)
          } else {
            texte = `Une erreur technique est survenue: ${error.message}`
          }
          this.$store.dispatch('afficherError', texte)
        })
    },

    obtenirDateLivraisonEstimee() {
      console.log('obtenirDateLivraisonEstimee')

      axios
        .get(
          `/calendrier/estimer/tp/${
            this.$store.getters.currentUser.clientData.idDemandeur
          }?tsCommande=${new moment().format('YYYY-MM-DDTHH:mm:ss')}`
        )
        .then(response => {
          let resp = response.data
          switch (resp.codeRetour) {
            case 'OK':
              this.dateEstimeeLivraisonTP = resp.resultat.dateLivraison

              this.dateEstimeeLivraisonTPValideJusqua =
                resp.resultat.dateLivraisonValideJusqua

              this.dateEstimeeCutOffDuration = moment.duration(
                this.getCutOffEstimeeDateLivraison().diff(moment())
              )

              this.$store.getters.currentUser.clientData.dateEstimeeLivraisonTP =
                resp.resultat.dateLivraison
              break
            case 'W001':
              break
            default:
              console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
              this.$store.dispatch(
                'afficherError',
                `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
              )
              break
          }
        })
        .catch(error => {
          //console.log('error=' + error)
          let texte = ''
          if (error.response) {
            texte = `Status: ${error.response.status} Data: ${error.response.data}`
            console.log(texte)
          } else {
            texte = `Une erreur technique est survenue: ${error.message}`
          }
          this.$store.dispatch('afficherError', texte)
        })

      // Heures de tombées
      axios
        .get(`/calendrier/heures`)
        .then(response => {
          let resp = response.data
          switch (resp.codeRetour) {
            case 'OK':
              this.heureTombeeLivraisonCDMTp = resp.resultat.heureTombeeCdmTP
              this.heureTombeeLivraisonCDQTp = resp.resultat.heureTombeeCdqTP
              break
            case 'W001':
              break
            default:
              console.log(`erreur resp.codeRetour=${resp.codeRetour}`)
              this.$store.dispatch(
                'afficherError',
                `Une erreur technique est survenue (${resp.codeRetour} - ${resp.messages} )`
              )
              break
          }
        })
        .catch(error => {
          //console.log('error=' + error)
          let texte = ''
          if (error.response) {
            texte = `Status: ${error.response.status} Data: ${error.response.data}`
            console.log(texte)
          } else {
            texte = `Une erreur technique est survenue: ${error.message}`
          }
          this.$store.dispatch('afficherError', texte)
        })
    },

    getCutOffEstimeeDateLivraison() {
      let heureTombee =
        this.$store.getters.currentUser.clientData.centreTraitement == 'CDM'
          ? this.heureTombeeLivraisonCDMTp
          : this.heureTombeeLivraisonCDQTp

      let time = moment(heureTombee, 'HH:mm')
      let date = moment(this.dateEstimeeLivraisonTPValideJusqua)

      date.set({ hour: time.get('hour'), minute: time.get('minute') })

      return date
    },

    lireDocuments() {
      axios
        .get(`/communication/obtenirfichiers/${this.communication.id}`)
        .then(response => {
          let resp = response.data
          let msg = null
          switch (resp.codeRetour) {
            case 'OK':
              this.fichiers = resp.resultat

              for (let i = 0; i < this.fichiers.length; i++) {
                if (this.fichiers[i].nomFichier == 'offre.jpg') {
                  this.fichierOffre = this.fichiers[i]
                  //} else if (this.fichiers[i].nomFichier == 'circulaire.jpg') {
                  //  this.fichierCirculaire = this.fichiers[i]
                }
              }

              break
            case 'W001':
              this.fichiers = []
              break
            default:
              msg = this.$fmtApiErr(resp)
              console.log(msg)
              this.$store.dispatch('afficherError', msg)
              break
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    exportRapportinventaireB2() {
      var liste = []
      axios
        .post(
          `/rapport/${this.$store.getters.currentUser.clientData.noClientJDE}/obtenirrapportinventaireb2/`,
          liste,
          {
            responseType: 'arraybuffer',
            headers: {
              Accept: 'application/vnd.ms-excel'
            }
          }
        )
        .then(response => {
          let ct = response.headers['content-type']
          if (ct == 'application/json') {
            const str = new TextDecoder().decode(response.data)
            const resp = JSON.parse(str)
            const msg = this.$fmtApiErr(resp)
            console.log(msg)
            this.$store.dispatch('afficherError', msg)
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'RapportProduitsDisponibles.xlsx')
            document.body.appendChild(link)
            link.click()
          }
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    },

    exportFichier(fichier) {
      console.log('exportFichier ' + fichier.id)

      var idFichier = fichier.id

      for (let i = 0; i < this.fichiers.length; i++) {
        // console.log(
        //   'fichiers : ' +
        //     this.fichiers[i].id +
        //    ' ' +
        //    this.fichiers[i].nomFichier
        // )

        if (fichier.nomFichier == 'offre.jpg') {
          idFichier = this.fichiers[i].id
        }
      }

      axios({
        url: '/communication/' + idFichier + '/fichier',
        method: 'get',
        responseType: 'arraybuffer'
        //headers: { Accept: 'application/pdf' }
      })
        .then(response => {
          let ct = response.headers['content-type']
          //if (ct == 'application/json') {
          // const str = new TextDecoder().decode(response.data)
          //  const resp = JSON.parse(str)
          //  const msg = this.$fmtApiErr(resp)
          //  console.log(msg)
          //  this.$store.dispatch('afficherError', msg)
          //} else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fichier.nomFichier)
          document.body.appendChild(link)
          link.click()
          //}
        })
        .catch(error => {
          console.log('error=' + error)
          let msg = this.$fmtAxiosErr(error)
          this.$store.dispatch('afficherError', msg)
        })
    }
  }
}
</script>

<style scoped>
.header {
  padding: 4px;
  text-align: left;
  color: white;
  font-size: 20px;
  width: 1500px;
}

.button {
  color: #343232;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0.43px;
  line-height: 12px;
}

.v-application a {
  color: white;
}

.oval {
  height: 80.81px;
  width: 80.81px;
  background-color: #00838e;
}
div {
  font-size: 14px;
}

.lien {
  font-weight: bold;
  color: black;
  font-size: 15px;
  text-decoration: underline;
}
</style>
